/* RIZZI · Complete the look: loads the pieces after the page, keeps them in step with the chosen colour
   and keeps adding pieces (8 at a time) when the shopper nears the end of the carousel.
   FERONDO v3 CRO: multi-buy prices on the cards, ported from SATRI's "Complete the look" (sections/satri-style-with):
   the tier shown is offerFor(c, inBag) = the tier the bag reaches after adding one suggestion, plus this product too
   when it is not in the bag yet (c = items in the bag, bag product ids from /cart.js). Tiers come from
   window.SATRI_OFFERS (snippets/satri-offer-calendar.liquid). Display only: the real discount is Shopify's automatic
   discount in the bag and at checkout. Two displays (holder data-price-mode, block setting "Price display"):
   - tier_main (default, SATRI): main price = tier price, normal price struck, note "{p}% off with {n} items in your bag".
   - real_main: the real price stays the main price (compare-at struck as before) + note "£X each with {n} in your bag". */
(function () {
  if (customElements.get('rizzi-complete-look')) return;

  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const CART_RE = /\/cart\/(add|change|update|clear)/;

  /* Bag state shared by every Complete the look on the page: item count + product ids, from /cart.js. */
  const Bag = (() => {
    let count = null;
    let ids = [];
    let timer = 0;
    const subs = new Set();
    const set = (cart) => {
      if (!cart || typeof cart.item_count !== 'number') return;
      count = cart.item_count;
      ids = (cart.items || []).map((it) => Number(it.product_id));
      subs.forEach((fn) => fn());
    };
    const refresh = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        fetch(ROOT + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then((r) => (r.ok ? r.json() : null))
          .then(set)
          .catch(() => {});
      }, 350);
    };
    try {
      new PerformanceObserver((list) => {
        if (list.getEntries().some((en) => CART_RE.test(en.name))) refresh();
      }).observe({ type: 'resource' });
    } catch (e) {}
    /* satri-cart-progress (bag drawer bar) dispatches 'satri:cart' with the /cart.js payload after each fetch. */
    document.addEventListener('satri:cart', (e) => (e && e.detail && e.detail.items ? set(e.detail) : refresh()));
    document.addEventListener('cart:updated', refresh);
    window.addEventListener('pageshow', (e) => { if (e.persisted) refresh(); });
    return {
      state: () => ({ count, ids }),
      subscribe: (fn) => { subs.add(fn); return () => subs.delete(fn); },
      refresh,
    };
  })();

  const NOTE = '{p}% off with {n} items in your bag';
  const HAVE = '{p}% off — already unlocked in your bag';

  function offers() {
    const O = window.SATRI_OFFERS;
    return O && O.current ? O : null;
  }
  // SATRI offerFor(c, inBag): tier reached after adding one suggestion (+ this product when it is not in the bag yet)
  function offerFor(O, c, inBag) {
    const tiers = O.current().tiers.slice().sort((a, b) => a.qty - b.qty);
    if (!tiers.length) return null;
    const target = c + (inBag ? 1 : 2);
    const t = O.tierFor(target, tiers);
    if (!t) return null;
    const cur = O.tierFor(c, tiers);
    return { pct: t.pct, n: target, have: !!(cur && cur.pct >= t.pct) };
  }

  class RizziCompleteLook extends HTMLElement {
    connectedCallback() {
      this.current = '';
      const start = () => {
        if (this.started) return;
        this.started = true;
        if (this.io) this.io.disconnect();
        this.load(this.dataset.variant);
      };
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver((entries) => {
          if (entries.some((e) => e.isIntersecting)) start();
        }, { rootMargin: '600px 0px' });
        this.io.observe(this);
      } else {
        start();
      }
      /* Also start once the page has finished loading and the browser is idle, so the pieces are ready before the shopper scrolls down. */
      const idle = () => (window.requestIdleCallback || ((cb) => setTimeout(cb, 1200)))(start, { timeout: 3000 });
      if (document.readyState === 'complete') idle();
      else window.addEventListener('load', idle, { once: true });
      if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const variant = event && event.data && event.data.variant;
          if (!variant || !this.loaded || String(variant.id) === this.current) return;
          this.load(variant.id);
        });
      }
      this.unbag = Bag.subscribe(() => this.paint());
      /* Size / option change updates the price shown on that card. */
      this.addEventListener('change', (event) => {
        const select = event.target;
        if (!select.classList || !select.classList.contains('rzcl__select')) return;
        const option = select.selectedOptions[0];
        const card = select.closest('.rzcl__card');
        if (!option || !card) return;
        card.querySelector('.rzcl__now').textContent = option.dataset.price || '';
        const was = card.querySelector('.rzcl__was');
        if (was) {
          was.textContent = option.dataset.compare || '';
          was.hidden = !option.dataset.compare;
        }
        card._rzReal = null;
        if (option.dataset.cents) card.dataset.cents = option.dataset.cents;
        card.dataset.compareCents = option.dataset.compareCents || '';
        this.paintCard(card);
      });
      if (document.readyState === 'complete') Bag.refresh();
      else window.addEventListener('load', () => Bag.refresh(), { once: true });
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.unsubscribe) this.unsubscribe();
      if (this.unbag) this.unbag();
    }

    load(variantId) {
      this.current = String(variantId || '');
      const url = this.dataset.url + (variantId ? '&variant=' + variantId : '');
      fetch(url)
        .then((r) => (r.ok ? r.text() : ''))
        .then((html) => {
          this.loaded = true;
          const box = html ? new DOMParser().parseFromString(html, 'text/html').querySelector('.rzcl') : null;
          if (!box) {
            this.replaceChildren();
            this.hidden = true;
            return;
          }
          this.hidden = false;
          this.replaceChildren(document.importNode(box, true));
          this.bind();
          this.paint();
        })
        .catch(() => {});
    }

    /* ---------- multi-buy prices (display only) ---------- */
    offer() {
      const O = offers();
      if (!O) return null;
      const st = Bag.state();
      const c = st.count === null ? Number(this.dataset.count) || 0 : st.count;
      const pid = Number(this.dataset.productId);
      return offerFor(O, c, !!pid && st.ids.indexOf(pid) !== -1);
    }

    paint() {
      const O = offers();
      const box = this.querySelector('.rzcl');
      if (!O || !box) return;
      /* v4: the phase can bring its own heading/line (Black Friday: copy.ctlTitle / ctlSub in the offer calendar);
         look 'bf' adds the black/yellow "Black Friday" label above the heading. Back to the section's heading otherwise. */
      let cc = {};
      let look = '';
      try { const cur = O.current(); cc = (cur && cur.copy) || {}; look = (cur && cur.look) || ''; } catch (e) {}
      const head = box.querySelector('.rzcl__heading');
      if (head) {
        if (head._rzReal === undefined) head._rzReal = head.innerHTML;
        if (cc.ctlTitle) {
          if (head.textContent !== cc.ctlTitle) head.textContent = cc.ctlTitle;
        } else if (head.innerHTML !== head._rzReal) {
          head.innerHTML = head._rzReal;
        }
        head.classList.toggle('rzcl__heading--bf', look === 'bf');
      }
      box.classList.toggle('rzcl--bf', look === 'bf');
      this._off = this.offer();
      let sub = box.querySelector('.rzcl__sub');
      if (this._off) {
        if (!sub) {
          sub = document.createElement('p');
          sub.className = 'rzcl__sub';
          const h = box.querySelector('.rzcl__heading');
          if (h) h.insertAdjacentElement('afterend', sub);
        }
        if (sub) sub.textContent = cc.ctlSub || O.t('completeSub', { p: O.maxPct() });
      } else if (sub) {
        sub.remove();
      }
      box.querySelectorAll('.rzcl__card').forEach((card) => this.paintCard(card));
    }

    paintCard(card) {
      const O = offers();
      if (!O) return;
      const now = card.querySelector('.rzcl__now');
      const was = card.querySelector('.rzcl__was');
      const note = card.querySelector('.rzcl__note');
      if (!now) return;
      /* Real (Liquid) price, kept so the card can always go back to it. */
      if (!card._rzReal) card._rzReal = { now: now.textContent, was: was ? was.textContent : '', wasHidden: was ? was.hidden : true };
      const real = card._rzReal;
      const cents = Number(card.dataset.cents);
      const off = this._off;
      const mode = this.dataset.priceMode === 'real_main' ? 'real_main' : 'tier_main';
      const restore = () => {
        now.textContent = real.now;
        if (was) { was.textContent = real.was; was.hidden = real.wasHidden; }
        card.classList.remove('rzcl__card--tier', 'rzcl__card--noted');
        if (note) { note.textContent = ''; note.hidden = true; }
      };
      if (!off || !cents || isNaN(cents)) { restore(); return; }
      const tier = Math.round((cents * (100 - off.pct)) / 100);
      if (!(tier < cents)) { restore(); return; }
      if (mode === 'tier_main') {
        now.textContent = O.formatMoney(tier);
        if (was) { was.textContent = O.formatMoney(cents); was.hidden = false; }
        card.classList.add('rzcl__card--tier');
        card.classList.remove('rzcl__card--noted');
        if (note) { note.textContent = O.fill(off.have ? HAVE : NOTE, { p: off.pct, n: off.n }); note.hidden = false; }
      } else {
        now.textContent = real.now;
        if (was) { was.textContent = real.was; was.hidden = real.wasHidden; }
        card.classList.remove('rzcl__card--tier');
        card.classList.add('rzcl__card--noted');
        if (note) {
          note.textContent = O.t(off.have ? 'eachHave' : 'eachInBag', { price: O.formatMoney(tier), n: off.n, p: off.pct });
          note.hidden = false;
        }
      }
    }

    bind() {
      const box = this.querySelector('.rzcl');
      const track = this.querySelector('.rzcl__track');
      if (!box || !track) return;
      const prev = this.querySelector('[data-rzcl-dir="-1"]');
      const next = this.querySelector('[data-rzcl-dir="1"]');
      const step = () => {
        const card = track.querySelector('.rzcl__card');
        return card ? card.getBoundingClientRect().width + 14 : track.clientWidth / 2;
      };
      [prev, next].forEach((btn) => {
        if (!btn) return;
        btn.addEventListener('click', () => track.scrollBy({ left: step() * Number(btn.dataset.rzclDir), behavior: 'smooth' }));
      });

      /* Endless part: after the chosen pieces, keep going through the same collections, then the whole shop. */
      const sources = (box.dataset.more || '')
        .split(',')
        .filter(Boolean)
        .map((handle) => ({ handle, page: 0, done: false }));
      const seen = new Set([box.dataset.self]);
      track.querySelectorAll('[data-pid]').forEach((n) => seen.add(n.dataset.pid));
      /* One colour per design in the endless part (each colour is its own product). */
      const nameOf = (li) => {
        const t = li.querySelector('.rzcl__title');
        return t ? t.textContent.split(' – ')[0].trim().toLowerCase() : '';
      };
      const seenName = new Set();
      track.querySelectorAll('.rzcl__card').forEach((li) => seenName.add(nameOf(li)));
      const own = document.querySelector('.product__title h1');
      if (own) seenName.add(own.textContent.split(' – ')[0].trim().toLowerCase());
      let busy = false;
      let cursor = 0;
      let finished = !sources.length;

      const fetchPage = (source) => {
        source.page += 1;
        const url = ROOT + 'collections/' + source.handle + '?section_id=rizzi-cl-more&page=' + source.page;
        return fetch(url)
          .then((r) => (r.ok ? r.text() : ''))
          .then((html) => {
            const list = html ? new DOMParser().parseFromString(html, 'text/html').querySelector('.rzcl-more') : null;
            if (!list) {
              source.done = true;
              return [];
            }
            if (source.page >= Number(list.dataset.pages || 0)) source.done = true;
            return Array.from(list.children);
          })
          .catch(() => {
            source.done = true;
            return [];
          });
      };

      const more = async () => {
        if (busy || finished) return;
        busy = true;
        let added = 0;
        let rounds = 0;
        while (added < 6 && rounds < 6 && track.isConnected) {
          rounds += 1;
          const open = sources.filter((s) => !s.done && s.handle !== 'all');
          const list = open.length ? open : sources.filter((s) => !s.done);
          if (!list.length) {
            finished = true;
            break;
          }
          const batch = [];
          for (let i = 0; i < Math.min(3, list.length); i++) batch.push(list[(cursor + i) % list.length]);
          cursor += batch.length;
          const results = await Promise.all(batch.map(fetchPage));
          if (!track.isConnected) break;
          const frag = document.createDocumentFragment();
          const fresh = [];
          const longest = Math.max(0, ...results.map((r) => r.length));
          for (let i = 0; i < longest; i++) {
            results.forEach((r) => {
              const li = r[i];
              if (!li || seen.has(li.dataset.pid)) return;
              seen.add(li.dataset.pid);
              const name = nameOf(li);
              if (name && seenName.has(name)) return;
              seenName.add(name);
              const node = document.importNode(li, true);
              fresh.push(node);
              frag.appendChild(node);
              added += 1;
            });
          }
          track.appendChild(frag);
          fresh.forEach((node) => this.paintCard(node));
        }
        busy = false;
        sync();
      };

      const sync = () => {
        const max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = finished && track.scrollLeft >= max;
        /* Start fetching while about two screens of pieces are still left. */
        if (!finished && track.scrollWidth - track.scrollLeft - track.clientWidth < track.clientWidth * 2) more();
      };
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    }
  }

  customElements.define('rizzi-complete-look', RizziCompleteLook);
})();
